import { T } from "@freightsimple/ui-core/Typography/T";
import YellowExclamationAnimatedIcon from "@/Shared/Animations/YellowExclamationAnimatedIcon";

function ShipmentNotFound() {
  return (
    <div className="flex flex-col items-center">
      <div className="h-[128px]" />
      <YellowExclamationAnimatedIcon />
      <div className="h-[16px]" />
      <T size="base" color="secondary">
        Sorry, we couldn&apos;t find this shipment
      </T>
    </div>
  );
}
export default ShipmentNotFound;
